import { OptionDto } from "@/dtos";
import { RouteRoadType } from "@/helpers/types";

const roadTypes = [
    { value: RouteRoadType.URBAN, label: 'Urbano' },
    { value: RouteRoadType.RURAL, label: 'Rural' },
    { value: RouteRoadType.CANTONAL, label: 'Cantonal' },
    { value: RouteRoadType.INTRACANTONAL, label: 'Intracantonal' },
    { value: RouteRoadType.INTERCANTONAL, label: 'Intercantonal' },
    { value: RouteRoadType.INTERPROVINCIAL, label: 'Interprovincial' },
] as OptionDto[];

export const getRouteRoadTypeOptions = (): OptionDto[] => {
    return roadTypes;
}

export const getRouteRoadTypeOption = (value?: number): OptionDto => {
    return roadTypes.find((x) => x.value == value) ?? roadTypes[0];
}

export const getRouteRoadTypeLabel = (value: number): string => {
    return roadTypes.find((x) => x.value == value)?.label ?? roadTypes[0].label;
}